<template>
    <div class="c-timesheet"
        :data-component-name="$options.name"
	>
        <div class="-group">
            <h4 class="-title">
                Temps d'équipe par contremaître
            </h4>
			<div class="-controls">
				<div class="-item">
					<div class="-name" @click="$refs['range-picker'].$refs.qDateProxy.show()">
						<RangePicker
							ref="range-picker"
							v-model="currentRange.str"
							@set-current-date="setCurrentRange($event)"
							class="q-mr-sm"
						/>
						Choisir une semaine
					</div>
				</div>
				<div class="-item" v-if="checkRules('staffs')">
					<UserProfileInput
						color="primary"
						popup-content-class="red"
						label="Contremaitre"
						:filled="false"
						borderless
						:multiple="false"
						v-model="userProfile"
						:popupContentClass="'c-moreFilters-popup'"
						:showMax="2"
						class="full-width"
						:clearable="userProfileID!=userProfile.id"
						:variables="{ role: 'FOREMAN' }"
					/>
					<!-- <UserProfileInput
						color="primary"
						popup-content-class="red"
						label="Contremaitre"
						:filled="false"
						borderless
						:multiple="false"
						v-model="userProfile"
						:popupContentClass="'c-moreFilters-popup'"
						:showMax="2"
						class="full-width"
						:clearable="userProfileID!=userProfile.id"
						:variables="{role: 'FOREMAN'}"
					/> -->
				</div>
			</div>
        </div>
        <div class="-group">
            <h4>
                <q-icon name="expand_more" class="-button-expand" />
                {{ perPage }} dernières semaines
            </h4>
            <div class="-item" :key="n" v-for="(week, n) in weeks"
                @click="downloadTimeSheet(week)"
            >
                <div class="-name">
                    <span>
                        <q-icon class="q-mr-xs" name="description" />
                        <span class="-hidden-mobile">
                            Semaine du
                        </span>
                        <strong>{{ date2str(week.obj.from).long }}</strong> au <strong>{{ date2str(week.obj.to).long }}</strong>
                    </span>
                    <q-icon name="file_download" class="-download-icon" />
                </div>
                <!-- {{ currentDate }} -->
            </div>
        </div>
    </div>
</template>

<script>
    import {/*getDatesBetween, getMonthLimits, dayOfWeekStr, monthStr, dayStr, */date2str, getWeeksLimits} from "@/js/dateUtilities"
    import { checkRouterRules } from '@/js/utilities'


	export default {
		name: "TimeSheetForemanComponent",
		props: {
		},
		data(){
			return {
                userProfileID: window.myUserProfileID,
                userProfile: window.myUserProfile,
				weeks: [],
				perPage: 15,
				httpEndpoint: this.$httpEndpoint.split('/'),
				currentRange: {},
				currentDate: new Date(),
				token: this.$q.localStorage.getItem('token')
			}
		},
		watch: {
			userProfile: function(){
				if(!this.userProfile) this.userProfile=window.myUserProfile
			}
		},
		methods: {
			setCurrentRange(date){
				this.currentRange=getWeeksLimits(date);
				this.downloadTimeSheet(this.currentRange)
			},
			date2str(date){
				return date2str(date);
			},
			downloadTimeSheet(dr){
				this.$axios({
					// url: this.httpEndpoint + "/download/timesheet/"+dr+"/1?ts="+new Date().getTime(),
					url: this.httpEndpoint + "/download/foremantimesheet/" + dr.str.from+'.'+dr.str.to + "/" + this.userProfile.id+"?ts="+new Date().getTime(),
					method: 'GET',
					// responseType: 'json',
					responseType: 'blob',
					headers:{
						"Authorization" : "Bearer "+this.token,
					}
				}).then((response) => {

					if (response.data.size == 0) {
						this.$q.notify({
							message: 'Aucune feuille de temps disponible pour cette semaine',
							color: 'negative',
						});
						return;
					}

					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					var fileLink = document.createElement('a');

					fileLink.href = fileURL;
					fileLink.setAttribute('download', 'FeuilleDeTemps_Équipe_'+this.userProfile.name+'_'+dr.str.to+'.xlsx');
					document.body.appendChild(fileLink);

					fileLink.click();
				}).catch(() => {
					this.$q.notify({
						message: 'Erreur lors du téléchargement de la feuille de temps',
						color: 'negative',
					});
				});
			},
            checkRules(routeName){
                return checkRouterRules(routeName, this.$router)
            }
		},
		mounted(){

			this.httpEndpoint.pop();
			this.httpEndpoint=this.httpEndpoint.join('/')

			if (location.host == "affectation-front.stereodev.ca") {
				this.httpEndpoint = 'https://affectation.stereodev.ca';
			}

			let myDate=new Date();
			this.currentRange=getWeeksLimits(this.currentDate);
			for(let i=0;i<this.perPage; i++){
				this.weeks.push(getWeeksLimits(myDate));
				myDate.setDate(myDate.getDate()-7);
			}

		},
	}
</script>
<style lang="scss">
	@import "@/scss/components/dashboard/Timesheet.scss";
</style>